import { useEffect } from "react";
import PageContainer from "@components/layout/PageContainer";
import { useParams } from "react-router-dom";
import styles from "./style.module.scss";
import BankAccountForm from "@components/forms/BankAccountForm";

const BankAccountAddEdit = () => {
  const params = useParams()
  const { id: bankAccountId } = params;

  useEffect(() => {
  }, []);

  return (
    <PageContainer
      containerClassName={styles.mainContainer}
      title={`${!bankAccountId ? 'Agregar' : 'Editar'} Cuenta Bancaria`}
      backUrl="/user/bank-accounts"
      primaryActions={[
        {
          actionTitle: "Guardar",
          formId: "bankAccountForm",
          type: "submit",
          color: "success"
        }
      ]}
    >
      <BankAccountForm
        formId="bankAccountForm"
        id={bankAccountId}
        saveRedirectUrl="/user/bank-accounts"
      ></BankAccountForm>

    </PageContainer>
  );
}

export default BankAccountAddEdit;
